import angular from 'angular';
import URLS from 'Helpers/urls';
import UTILS from 'Helpers/util';

(function() {
    'use strict';

    angular.module('app').component('demoteacher', {
        template: require('./demo-teacher.html'),
        controller: DemoTeacherCtrl,
        controllerAs: 'vm'
    }).directive('imageonload', function() {
        return {
            restrict: 'A',
            scope: { teacher: '=teacher' },
            link: function(scope, element, attrs) {
                element.bind('load', function() {
                });
                element.bind('error', function(){
                    scope.teacher.invisible='true';
                    scope.$apply();
                });
            }
        };
    });;

    DemoTeacherCtrl.$inject = [
        '$scope',
        '$state',
        '$stateParams',
        '$rootScope',
        'ModalService',
        'QueryService',
        'SessionService',
        'logger'
    ];

    function DemoTeacherCtrl(
        $scope,
        $state,
        $stateParams,
        $rootScope,
        ModalService,
        QueryService,
        SessionService,
        logger
    ) {
        var vm = this;
        vm.isPassword = false;
        vm.logo = require('Images/nav-logo.png');
        vm.mainBackground = require('Images/bunny.png');

        vm.area_codes = require('Images/area_codes.json');
        vm.area_code = `${vm.area_codes[0].name} (${vm.area_codes[0].dial_code})`;

        // The header text on top most of the page
        vm.header = 'Login';
        vm.page = 0;

        vm.retrieve_teachers = retrieve_teachers;

        $rootScope.title = '다영이 체험수업 신청';
        vm.references = [
            {
                display_name: '네이버 검색 ( Naver search )',
                id: 'naver'
            },
            {
                display_name: '구글 검색 ( Google Search )',
                id: 'google'
            },
            {
                display_name: '지인 소개 ( Referral )',
                id: 'referral'
            },
            {
                display_name: '전단지 ( Flyers )',
                id: 'flyers'
            },
            {
                display_name: '고파스 ( Koreapas )',
                id: 'koreapas'
            },
            {
                display_name: '페이스북 ( Facebook )',
                id: 'facebook'
            },
            {
                display_name: '인스타그램 ( Instagram )',
                id: 'instagram'
            },
            {
                display_name: '네이버 블로그 ( Naver Blog )',
                id: 'naver_blog'
            }
        ];
        vm.levels = [
            { display_name: '왕초보 / Low Beginner' },
            { display_name: '초보 / Beginner' },
            { display_name: '중급 / Intermediate' },
            { display_name: '중상급 / Upper intermediate' },
            { display_name: '상급 / Advanced' }
        ];

        vm.regular_minutes = [
            { display_name: '15 minutes' },
            { display_name: '20 minutes' },
            { display_name: '25 minutes' },
            { display_name: '30 minutes' },
            { display_name: '45 minutes' },
            { display_name: '60 minutes' }
        ];
        vm.regular_minutes2 = vm.regular_minutes.slice();

        vm.topics = [
            {
                display_name: '일상 이야기 ( Daily Life )',
                id: 'daily_life'
            },
            {
                display_name: '정치&경제 ( Politics&Economy )',
                id: 'polititcs'
            },
            {
                display_name: '비즈니스 ( Business )',
                id: 'business'
            },
            {
                display_name: '여행 ( Travel )',
                id: 'travel'
            },
            {
                display_name: '사랑 ( Love )',
                id: 'love'
            },
            {
                display_name: '한국 문화와 역사 ( Korean Culture & History )',
                id: 'khist'
            },
            {
                display_name: '필리핀 문화와 역사 ( Philippines Culture & History )',
                id: 'phist'
            },
            {
                display_name: '생각나는대로 ( Anything )',
                id: 'anything'
            }
        ];

        vm.data = {};
        vm.days = [
            'Sundays',
            'Mondays',
            'Tuesdays',
            'Wednesdays',
            'Thursdays',
            'Fridays'
        ];

        vm.alphabet = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
        vm.data.coupon_code = $stateParams.coupon_code;

        vm.submit = function() {

            vm.data.demo_class_teachers = vm.selected_teachers;
            vm.data.tags = vm.selected_tags.map(t => t.english_text).join();

            const phone = '('+(vm.area_code || '(+82)').split('(')[1]+vm.data.phone

            console.log(vm.data);

            if (vm.data.preferred_regular_minutes1)
                vm.data.preferred_regular_minutes1 = parseInt(
                    vm.data.preferred_regular_minutes1.split(
                        ' '
                    )[0]
                );

            vm.loading = true;
            var request = {
                method: 'POST',
                body: { ... vm.data, phone },
                params: false,
                hasFile: false,
                route: URLS.base + `/demo_class_teacher`,
                cache: false
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        vm.submitted_view = true;
                        vm.page = 3;
                    },
                    function(error) {
                        logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });
        };

        // vm.demo1 = function() {
        //     show_hour_picker('demo1', 'multiple', '체험수업 일정을 선택해 주세요');
        // };
        // vm.demo2 = function() {
        //     show_hour_picker(
        //         'demo2',
        //         'multiple',
        //         'Select time for demo class option 2'
        //     );
        // };

        // vm.regular1 = function() {
        //     show_regular_class('regular1', '희망 정규수업 일정을 선택해 주세요');
        // };

        // vm.regular2 = function() {
        //     show_regular_class(
        //         'regular2',
        //         'Select time for regular class option 2'
        //     );
        // };

        // function show_hour_picker(path, mode, header) {
        //     var modal = {
        //         header: header,
        //         mode: mode
        //     };

        //     ModalService.hour_picker_modal(modal, vm.TPLS).then(
        //         function(response) {
        //             vm[path + '_string'] =
        //                 '<h4><strong>' +
        //                 response[0].date.format('YYYY-MM-DD') +
        //                 '</strong></h4>   ' +
        //                 response
        //                     .map(x => {
        //                         return (
        //                             '<strong>' +
        //                             x.date.format('HH:mm') +
        //                             '</strong>'
        //                         );
        //                     })
        //                     .join('  or  ');

        //             vm.data[path] = response;
        //         },
        //         function(error) {
        //             logger.errorFormatResponse(error);
        //         }
        //     );
        // }

        // function show_regular_class(path, header) {
        //     var modal = {
        //         header: header
        //     };

        //     ModalService.regular_class_modal(modal, vm.TPLS).then(
        //         function(response) {
        //             vm[path + '_string'] =
        //                 '<h4><strong>' +
        //                 vm.to_time(response[0].hour) +
        //                 '</strong></h4>   ' +
        //                 response
        //                     .map(x => {
        //                         return (
        //                             '<strong>' + vm.days[x.day] + '</strong>'
        //                         );
        //                     })
        //                     .join('  |  ');

        //             vm.data[path] = response;
        //         },
        //         function(error) {
        //             logger.errorFormatResponse(error);
        //         }
        //     );
        // }

        vm.to_time = function(hour) {
            return (
                ('' + parseInt(hour / 4)).padStart(2, 0) +
                ':' +
                ('' + hour % 4 * (60 / 4)).padStart(2, 0)
            );
        };

        function retrieve_teachers(){
            const query = {};

            if(vm.startsWith){
                query.startsWith = vm.startsWith;
            }

            if(vm.selected_tags.length > 0){
                query.tags = vm.selected_tags.map(t => t.id);
            }

            var request = {
                method: 'GET',
                params: query,
                hasFile: false,
                route: URLS.base + `/teacher/profiles`,
                cache: false
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        vm.teachers = response.data.data.items;
                    },
                    function(error) {
                        logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                });
        };

        vm.selected_tags = [];
        retrieve_tags();
        function retrieve_tags(){
            const query = {};

            var request = {
                method: 'GET',
                params: query,
                hasFile: false,
                route: URLS.base + `/tag`,
                cache: false
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        vm.tags = response.data.data.items;
                    },
                    function(error) {
                        logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                });
        };

        vm.click_tag = (tag) => {
            const is_selected = vm.selected_tags.includes(tag);
            console.log(is_selected);
            if(!is_selected){
                vm.selected_tags.push(tag);
                retrieve_teachers();
            }else{
                vm.selected_tags = vm.selected_tags.filter(s => s.id !== tag.id);
                retrieve_teachers();
            }
        };

        vm.selected_teachers = [
        ];

        vm.tap_teacher = (teacher) => {

            if(!teacher.selected){

                var modal = {
                    coupon_code: $stateParams.coupon_code,
                    teacher: teacher,
                    teacher_count: vm.selected_teachers.length + 1
                };

                ModalService.teacher_modal(modal, vm.TPLS).then(
                    function(response) {
                        Object.assign(response, teacher)
                        console.log(response);

                        if(response.finalized){
                            teacher.selected = true;
                            vm.selected_teachers.push(response);
                        }

                        if(!response.next){
                            // go to next page
                            vm.page = vm.page + 1;
                        }

                    },
                    function(error) {
                        logger.errorFormatResponse(error);
                    }
                );
            } else {
                teacher.selected = false;
                //remove teacher
                vm.selected_teachers = vm.selected_teachers.filter((t) => {
                    return t.id != teacher.id;
                });

            }

        };

        retrieve_teachers();

        vm.go_back = function(){
            $state.go('demo');
        }

    }
})();



// WEBPACK FOOTER //
// ./src/app/components/demo-teacher/demo-teacher.component.js